import { useState } from "react";

export default function ContentTabs({ items }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeItem = items[activeIndex];

  const handleChange = (index) => {
    setActiveIndex(index);
  };

  return (
    <div>
      <div className="flex gap-7 border-b-[1px] border-purple pt-4 md:pt-9 overflow-x-auto no-scrollbar">
        {items.map((c, i) => (
          <div
            key={i}
            className={`${
              activeIndex === i ? "text-purple font-medium" : "text-grey-300"
            } pb-4 text-base md:text-lg lg:text-xl cursor-pointer`}
            onClick={() => handleChange(i)}
          >
            <span className="whitespace-nowrap">{c.title}</span>
          </div>
        ))}
      </div>
      <div className="pt-5 md:pt-12 flex flex-col justify-between gap-6 md:gap-20 md:flex-row xl:gap-40">
        <div className="w-[100%] md:max-w-[50%] flex flex-col gap-8 md:gap-16 3xl:max-w-[60%]">
          <div
            id="dynamicContent"
            className="text-purple"
            dangerouslySetInnerHTML={{ __html: activeItem.description }}
          />
        </div>
        {activeItem.img ? (
          <img
            src={activeItem.img}
            alt="image"
            className="max-w-[550px] h-[360px] object-cover"
          />
        ) : activeItem.content ? (
          <div className="w-[100%] lg:max-w-[624px] bg-purple flex flex-col justify-center p-4 sm:p-[50px] 3xl:max-w-[40%]">
            <div className="flex flex-col gap-4">
              <div
                id="dynamicSpecialismContent"
                className="talent-description text-[#FBFF20]"
                dangerouslySetInnerHTML={{ __html: activeItem.content }}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
